import {Grid2, Skeleton} from '@mui/material';

const BannerChargeWallet = () => (
  <Grid2 mt={2}>
    <Skeleton
      variant="rectangular"
      width={'100%'}
      height={'124px'}
      sx={{borderRadius: '8px'}}
    />
  </Grid2>
);

export default BannerChargeWallet;
